// latest: wjk 2017-8-11 3:19 PM
// 鞍钢采购分类参照
import Collection from 'common/vo/collection'
import 'collection/filterMaterialClass'
/* global $ u __ */

let _config
function init (refer) {
  // 每次都重新加载
  // debugger
  let collection = Collection.create('collection.filterMaterialClass')
  let selectedData = []
  let selectflag = false
  collection.on('data', function (result) {
    // debugger
    if (_config.multiSelect) {
      let selectIndex = []
      if (selectedData.length > 0) {
        // debugger
        result.data.result.forEach(function (listItem, i) {
          selectedData.forEach(function (item) {
            if (item.id === listItem.id) {
              selectIndex.push(i)
            }
          })
        })
      } else if (refer.options.defaultData) {
        // debugger
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          defaultData.forEach(function (item) {
            let flag = false
            result.data.result.forEach(function (listItem, i) {
              if (!flag && item.id === listItem.id) {
                selectIndex.push(i)
                selectedData.push({
                  id: listItem.id.value,
                  name: listItem.className.value,
                  fullPath: listItem.fullPath.value,
                  code: listItem.code.value,
                })
                flag = true
              }
            })

            if (!flag) {
              selectedData.push(item)
            }
          })
        }
      }

      if (selectIndex.length > 0) {
        collection.datatable.setRowsSelect(selectIndex)
      }
    }
    selectflag = true
  })
  // 加载数据
  collection.load()

  let vm = {
    config: {
      id: 'saleorg_grid1',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'code',
        'dataType': 'String',
        'title': __('code'),
        'width': '48%'
      }, {
        'field': 'fullPath',
        'dataType': 'String',
        'title': __('name'),
        'width': '48%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#saleorg_refer')[0])

  // 提交事件
  refer.registerSubmitFunc(() => {
    // debugger
    return selectedData
  })

  // 移除选择事件
  collection.datatable.on('unSelect', function (obj) {
    // debugger
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = -1
    selectedData.forEach(function (item, i) {
      if (item.id === selectData.getValue('id')) {
        index = i
      }
    })
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  // 选择事件
  collection.datatable.on('select', function (obj) {
    debugger
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      selectedData = {
        id: selectData.id.value,
        name: selectData.className.value,
        fullPath: selectData.fullPath.value,
        code: selectData.code.value,
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      selectedData.push({
        id: selectData.id.value,
        name: selectData.className.value,
        fullPath: selectData.fullPath.value,
        code: selectData.code.value,
        // materialClassId: selectData.materialClassId.value
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    multiSelect: true
  }, config)

  return { init, template }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/filterMaterialClass/index.js